<template>
  <div
    class="biBarWrap biLineWrap"
    ref="biLineWrap">
    <svg
      v-if="data && data.length"
      ref="svg"
      :width="clientWidth"
      :height="clientHeight"
      :class="{'biChartBlur': refresh !== 0}">
      <bi-label
        :data="classes.data"
        :options="classes.options"
        @classesClick="classesClick"/>
      <g
        class="area"
        ref="area">
        <g
          class='scroll'
          ref="scroll">
          <g
            class="rect"
            ref="rect"/>
        </g>
        <g
          class="axisX"
          ref="axisX"/>
        <g
          class="axisY"
          ref="axisY"/>
      </g>
      <defs>
        <clipPath :id="hashId">
          <rect
            :width="innerWidth"
            :height="innerHeight"
            :x="maxLeft"
            :y="top"/>
        </clipPath>
      </defs>
    </svg>
    <div
      class="center-p"
      v-show="refresh === 0 && !(classes.data.length) || refresh === 1 || refresh === 2 || refresh === 3">
      <el-tag type="warning"><i
        class="el-icon-loading"
        v-show="refresh === 1"/>{{ message[refresh] }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="reload"
        v-show="refresh === 0">
        <i class="el-icon-refresh"/>点击刷新
      </el-button>
    </div>
    <bi-tool-tip
      class="tooltip"
      :data="tooltip"/>
  </div>
</template>

<script>
import * as d3 from 'd3';
import Common from '@/components/charts/common';

export default {
  mixins: [Common],
  data() {
    return {
      defaultOptions: {
        width: 0,
        height: 0,
        margin: {
          top: 50, right: 24, bottom: 20, left: 40
        },
        domainType: 'number',
        domainX: null,
        domainY: null,
        curve: '',
        groupType: true,
        exLabel: '%%',
        duration: 400,
        labelWidthPercent: 25
      },
      scrollY: 0,
      bar: {
        defaultBarWidth: 30,
        barStep: 0,
      },
      init: false,
    };
  },
  props: {},
  computed: {
    maxLeft() {
      return Math.max((d3.max(this.data, d => d.label.length) * 16) + 2, this.left);
    },
    maxRight() {
      // 因为是数字，所以宽度有修改
      let right = ((this.clientWidth - this.option.margin.right)
        - (d3.max(this.data, d => d.value.toString().length) * 10));
      return right;
    },
    innerWidth() {
      return this.right - this.maxLeft;
    },
    scaleX() {
      let scale;
      if (this.option.domainX) {
        switch (this.option.domainType) {
          case 'time':
            scale = d3.scaleTime().range([this.top, this.bottom]);
            break;
          case 'string':
            scale = d3.scaleBand().range([this.top, this.bottom])
              .domain(this.option.domainX);
            break;
          default:
            scale = d3.scaleLinear().range([this.top, this.bottom])
              .domain(d3.extent(this.option.domainX, d => d).reverse());
        }
      }
      return scale;
    },
    scaleY() {
      return d3.scaleLinear().range([this.maxLeft, this.maxRight]);
    },
  },
  methods: {
    createSvg() {
      if (this.data.length === 0) return;
      this.initData();
    },
    createAllAttr() {
      d3.select(this.$refs.axisX).selectAll('*').remove();
      d3.select(this.$refs.axisY).selectAll('*').remove();
      d3.select(this.$refs.rect).selectAll('*').remove();
      // 画轴
      // this.scaleX.domain(this.option.domainX);
      let classes = this.classes.data;
      // 这里只计算分组柱，叠柱形式还未计算
      let values = [];
      if (this.groupType) {
        values = this.data.map((d) => {
          if (this.getLabelStatus(d.class, classes)) {
            return d.value;
          }
          return 0;
        });
      } else {
        this.data.map((d) => {
          if (this.getLabelStatus(d.class, classes)) {
            if (!values[d.label]) {
              values[d.label] = 0;
            }
            values[d.label] += d.value;
          }
          return 0;
        });
        values = d3.values(values);
      }

      this.scaleY.domain([0, d3.max(values, d => d) || 1]);
      let axisX = d3.select(this.$refs.axisX)
        .attr('transform', `translate(${this.maxLeft}, 0)`)
        .call(d3.axisLeft(this.scaleX));
      axisX
        .select('path')
        .remove();
      axisX
        .selectAll('line')
        .remove();
      axisX
        .selectAll('text')
        .style('font-size', '14px');
      // const tick = (d3.max(values, d => d) / 5) | 0;
      /*
      d3.select(this.$refs.axisY)
        .attr('transform', `translate(0, ${this.bottom})`)
        .call(d3.axisBottom(this.scaleY));
*/
      const domainX = this.option.domainX;
      this.bar.barStep = this.dataWidth / domainX.length; // 实际刻度的长度
      // let myBarWidth = this.getTrueNum(this.bar.barStep, barWidth); // 实际矩形宽度
      let myBarWidth = this.scaleX.bandwidth() - 10; // 实际矩形宽度
      // this.bar.defaultBarWidth = myBarWidth;
      // 每组数据矩形数量，叠柱始终为1
      let num = this.option.groupType ? d3.sum(this.classes.data.map(d => +d.status)) : 1;
      // 返回加工好的数据
      this.bar = Object.assign({}, this.bar, {
        barWidth: myBarWidth,
        barLeft: (this.bar.barStep - (myBarWidth * num)) / 2
      });
    },
    // 每一个rect是通过左上角坐标定位的
    initData() {
      if (this.option.domainX && this.option.domainY) {
        this.createAllAttr();
      } else {
        // 输出一个无数据的效果
        return null;
      }
      // this.svg = d3.select(this.$refs.rect);
      const { barWidth, barLeft } = this.bar;
      // let i = 0;
      let rect = d3.select(this.$refs.rect);
      rect.attr('clip-path', `url(#${this.hashId})`);
      this.update = rect.selectAll('.rect').data(this.data).remove();
      let enter = this.update.enter();
      // let exit = this.update.exit();

      if (this.option.groupType) {
        // 普通分组矩形绘画
        enter
          .append('rect')
          .attr('fill', d => this.getColor(d.class, this.classes.data))
          .attr('class', d => `rect${d.label}`)
          .attr('y', (d) => {
            // 普通计算横轴位移
            let width = (this.scaleX(d.label)
              + (this.getRealIndex(d.class, this.classes.data) * barWidth));
            return (width + barLeft) - 1;
          })
          .attr('height', barWidth)
          .attr('x', this.maxLeft)
          .attr('width', 0)
          .transition()
          .duration(this.duration)
          .attr('width', (d) => {
            return this.getLabelStatus(d.class, this.classes.data)
              ? Math.max(this.scaleY(d.value) - this.maxLeft, 0) : 0;
          })
          .ease(d3.easeElastic);
        enter
          .append('text')
          .attr('x', (d) => {
            return 3 + (this.getLabelStatus(d.class, this.classes.data)
              ? Math.max(this.scaleY(d.value), 0) : 0);
          })
          .attr('y', (d) => {
            // 普通计算横轴位移
            let width = (this.scaleX(d.label)
              + (this.getRealIndex(d.class, this.classes.data) * barWidth));
            return (width + barLeft) + 12;
          })
          .style('text-auchor', 'start')
          .text(d => d.value);
      } else {
        // 叠柱绘画
        let groupRect = [];
        enter
          .append('rect')
          .attr('fill', d => this.getColor(d.class, this.classes.data))
          .attr('class', d => `rect${d.label}`)
          .attr('y', (d) => {
            // 普通计算横轴位移
            return this.scaleX(d.label) + barLeft;
          })
          .attr('height', () => {
            return barWidth;
          })
          .attr('x', this.maxLeft)
          .attr('width', 0)
          .transition()
          .duration(this.duration)
          .attr('y', (d) => {
            let y = d.value;
            if (groupRect[d.label]) {
              y = groupRect[d.label] + d.value;
            }
            groupRect[d.label] = y;
            return this.scaleX(y);
          })
          .attr('width', (d) => {
            return this.getLabelStatus(d.class, this.classes.data)
              ? Math.max(this.scaleY(d.value) - this.maxLeft, 0) : 0;
          })
          .ease(d3.easeElastic);
      }
    },
    classesClick(ix) {
      this.classes.data = this.changeClassStatus(ix, this.classes.data);
      this.initData();
    },
    getRealIndex(text, classes) {
      let index = 0;
      if (classes) {
        for (let i = 0; i < classes.length; i++) {
          if (classes[i].title === text) {
            break;
          }
          if (classes[i].status) {
            index++;
          }
        }
      }
      return index;
    }
  },
  watch: {
    data() {
      this.scrollY = 0;
      this.$nextTick(() => {
        if (this.option.classes) {
          this.classes.data = this.option.classes.map((d, i) => {
            return {
              title: d,
              color: this.colors[i],
              type: 'bar',
              status: true,
              view: true
            };
          });
          this.classes.options = {
            panelWidth: this.clientWidth,
            labelWidthPercent: this.option.labelWidthPercent
          };
        }
        if (!this.init) {
          this.createSvg();
          this.init = true;
        } else {
          this.initData();
        }
      });
    }
  }
};
</script>

<style>
.biBarWrap {
  position: relative;
  height: 100%;
}

.biChartBlur {
  opacity: .25;
  filter: blur(12px);
}

.biBarWrap svg {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.biBarWrap .axis path,
.biBarWrap .axis line {
  fill: none;
  stroke: black;
  shape-rendering: crispEdges;
}

.biBarWrap .center-p {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.biBarWrap .center-p .state {
  position: relative;
  z-index: 100;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.biBarWrap .center-p button {
  margin-top: 20px;
}

.biBarWrap .focusBar rect {
  fill: none;
  pointer-events: all;
}
</style>
